import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {
    doctor: [],
    patient: [],
  },
};

export const AppointmentSlice = createSlice({
  name: "AppointmentReducer",
  initialState,
  reducers: {
    setAppointmentList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setDoctorComboList: (state, action) => {
      state.filters.doctor = action.payload;
    },
    setPatientComboList: (state, action) => {
      state.filters.patient = action.payload;
    },
  },
});

export const { setAppointmentList, setDoctorComboList, setPatientComboList } =
  AppointmentSlice.actions;

export default AppointmentSlice.reducer;
